@if (orderStatus === 'NEW_ORDER') {
<div class="card p-fluid">
    <div class="flex justify-content-between flex-wrap">
        <div class="flex justify-content-center mb-3">
            <label class="card-heading uppercase" translate>order.lbl_product</label>
        </div>
    </div>
    <div>
        <p-table [value]="products" showGridlines class="custom-bordered-table">
            <ng-template pTemplate="header">
                <tr>
                    <th translate>lbl_name</th>
                    @if( configService.isSiteUser() && isPatientManagmentOn) {
                    <th translate>protocol.lbl_patients</th>
                    }
                    <th translate>order.lbl_qty</th>
                    @if (configService.isTenantAdmin() || configService.isReviewer()) {
                    <th translate>order.lbl_unit_cost</th>
                    <th translate>order.lbl_price</th>
                    <th translate>order.lbl_total</th>
                    }
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-product>
                <tr>
                    <td>{{ product.name }}</td>
                    @if( configService.isSiteUser() && isPatientManagmentOn) {
                    <td>
                        <a class="view-patient-link" (click)="openPatientDialog(product.patientCodes)">
                            <span translate>order.lbl_view_patient</span>
                        </a>
                    </td>
                    }
                    <td>{{ product.qty }}</td>
                    @if (configService.isTenantAdmin() || configService.isReviewer()) {
                    <td>${{ product.unitCost | number:'1.2-2' }}</td>
                    <td>${{ product.price | number:'1.2-2' }}</td>
                    <td>${{ product.total | number:'1.2-2' }}</td>
                    }
                </tr>
            </ng-template>
        </p-table>
    </div>
    @if(orderSummary.length) {
    <div class="flex justify-content-end mt-4">
        <div class="w-4">
            <p-table [value]="orderSummary" showGridlines class="custom-bordered-table">
                <ng-template pTemplate="header">
                    <tr>
                        <th translate>order.lbl_order_summary</th>
                        <th></th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-product let-rowIndex="rowIndex">
                    <tr [ngClass]="{ 'last-row': rowIndex === orderSummary.length - 1 }">
                        <td>{{ product.name }}</td>
                        <td [ngClass]="{ 'last-row': rowIndex === 0 }">
                            @if (product.isPrice) {
                            <span>$</span>{{product.qty | number:'1.2-2'}}
                            } @else {
                            {{product.qty}}
                            }
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </div>
    }

    <app-patient-info
        [visible]="showPatientDialog"
        [patientCodes]="selectedPatientCodes"
        (onClose)="closePatientDialog()">
    </app-patient-info>
</div>
}